import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  CreateMyArticleUseCaseInput,
  CreateMyArticleUseCaseOutput,
  IAppErrorFactory,
  IArticlesService,
  ICreateMyArticleUseCase,
  IUserArticleFactory,
} from '../../types'

@injectable()
export default class CreateMyArticleInteractor implements ICreateMyArticleUseCase {
  @inject(symbols.IArticlesService) private articlesService: IArticlesService

  @inject(symbols.IUserArticleFactory) private userArticleFactory: IUserArticleFactory

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: CreateMyArticleUseCaseInput): Promise<CreateMyArticleUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      const base = await this.articlesService.createMyArticle(input)
      output.article = this.userArticleFactory.create({ base })
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): CreateMyArticleUseCaseOutput {
    return {
      article: null,
      error: null,
    }
  }
}
